// extracted by mini-css-extract-plugin
export default {"container":"src-components-Filter-next-components-SbFilterChipsNext__container--Qkn65"};